// extracted by mini-css-extract-plugin
export default {"option":"select-option_option__9vBnD","option--primary":"select-option_option--primary__HAmcV"};